module.exports = __webpack_public_path__ + "static/media/29BDOS9.bcd4a635.jpg";